import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [cartCount] = useState(2); // Nombre d'articles dans le panier
  const location = useLocation();

  return (
    <nav className="bg-white sticky top-0 z-50 px-4 lg:px-0">
      <div className="md:mx-8 lg:mx-16 mx-auto">
      {/* Barre supérieure */}
      <div className="bg-white border-b border-gray-100 py-3">
        <div className="mx-auto">
          <div className="flex items-center justify-between h-16">
            {/* Logo et livraison */}
            <div className="flex items-center space-x-4">
              <img className="w-42 h-12" src="/images/logo.png" alt="logo" />
              <div className="hidden lg:block border-l-2 border-gray-400 pl-4">
                <span className="text-sm text-gray-500">Livraison au <b>Togo</b></span>
              </div>
            </div>

            {/* Barre de recherche */}
            <div className="hidden lg:flex max-w-2xl mx-8">
              <div className="relative w-full">
                <input
                  type="text"
                  placeholder="Recherche..."
                  className="w-full pl-4 pr-20 py-2 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-orange-light focus:border-transparent"
                />
                <div className="absolute right-2 top-1/2 transform -translate-y-1/2 flex items-center space-x-2">
                  <button className="p-1 hover:bg-gray-100 rounded-full">
                    <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                  </button>
                  <div className="h-4 bg-gray-300"></div>
                  <button className="p-1 hover:bg-gray-100 rounded-full">
                    <img className="w-4 h-4" src="/svg/nav-search.svg" alt="search" />
                  </button>
                </div>
              </div>
            </div>

            {/* Utilitaires utilisateur */}
            <div className="flex items-center space-x-4">
              <div className="hidden md:flex items-center space-x-4 text-sm text-gray-600 font-medium">
                <span>Français - XOF</span>
                <img className="w-5 h-5" src="/svg/globe.svg" alt="globe" />
              </div>

              <button className="p-2 hover:bg-gray-100 rounded-full relative">
                <img className="h-5 w-5" src="/svg/love.svg" alt="love" />
              </button>

              <Link to="/cart" className="p-2 hover:bg-gray-100 rounded-full relative">
                <svg xmlns="http://www.w3.org/2000/svg" width="21.283" height="21.283" viewBox="0 0 21.283 21.283">
                  <g id="Groupe_8601" data-name="Groupe 8601" transform="translate(0.75 0.75)">
                    <path id="Tracé_13756" data-name="Tracé 13756" d="M1148.968,58.484A1.484,1.484,0,1,1,1147.484,57,1.483,1.483,0,0,1,1148.968,58.484Z" transform="translate(-1140.064 -40.184)" fill="none" stroke="#141c1d" stroke-width="1.5" />
                    <path id="Tracé_13757" data-name="Tracé 13757" d="M1157.968,58.484A1.484,1.484,0,1,1,1156.484,57,1.483,1.483,0,0,1,1157.968,58.484Z" transform="translate(-1140.162 -40.184)" fill="none" stroke="#141c1d" stroke-width="1.5" />
                    <path id="Tracé_13758" data-name="Tracé 13758" d="M1143.957,41.978h11.87a3.956,3.956,0,0,1,3.957,3.957v4.946a3.956,3.956,0,0,1-3.957,3.957h-7.913a3.956,3.956,0,0,1-3.956-3.957Zm0,0A1.981,1.981,0,0,0,1141.978,40H1140m3.957,5.935h15.332" transform="translate(-1140 -40)" fill="none" stroke="#141c1d" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
                  </g>
                </svg>
                {cartCount > 0 && (
                  <span className="absolute -top-0 -right-0 bg-orange-light text-white text-xs rounded-full h-4 w-4 flex items-center justify-center">
                    {cartCount}
                  </span>
                )}
              </Link>

              <Link to="/account" className="p-2 hover:bg-gray-100 rounded-full">
                <img className="w-5 h-5" src="/svg/nav-user.svg" alt="user" />
              </Link>

              <Link
                to="/vendor/login"
                className="bg-orange-hover text-white px-4 py-2 rounded-full text-sm font-medium hover:bg-orange-light transition-colors hidden md:inline-block"
              >
                Se connecter
              </Link>

              {/* Menu mobile */}
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="md:hidden p-2 hover:bg-gray-100 rounded-full"
              >
                <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      </div>


      {/* Barre de navigation inférieure */}
      <div className="bg-gray-100 ">
        <div className="md:mx-8 lg:mx-16 mx-auto">
          <div className="flex items-center justify-between h-14">
            {/* Navigation principale */}
            <div className="hidden md:flex items-center space-x-8 text-sm font-medium">
              <Link
                to="/"
                className={`transition-colors hover:underline ${
                  location.pathname === "/" 
                    ? "text-red-600 font-medium" 
                    : "text-gray-700 hover:text-gray-900"
                }`}
              >
                Accueil
              </Link>
              <Link
                to="/boutiques"
                className={`transition-colors hover:underline ${
                  location.pathname === "/boutiques" 
                    ? "text-orange-light font-medium" 
                    : "text-gray-700 hover:text-gray-900"
                }`}
              >
                <span>Boutiques</span>
              </Link>
              <Link
                to="/categories"
                className={`transition-colors hover:underline ${
                  location.pathname === "/categories" 
                    ? "text-orange-hover font-medium" 
                    : "text-gray-700 hover:text-gray-900"
                }`}
              >
                <span>Catégories</span>
              </Link>
              <Link
                to="/promotions"
                className={`transition-colors hover:underline ${
                  location.pathname === "/promotions" 
                    ? "text-orange-light font-medium" 
                    : "text-gray-700 hover:text-gray-900"
                }`}
              >
                Promotions
              </Link>
              <Link
                to="/help"
                className={`transition-colors hover:underline ${
                  location.pathname === "/help" 
                    ? "text-orange-light font-medium" 
                    : "text-gray-700 hover:text-gray-900"
                }`}
              >
                Aide / FAQ
              </Link>
              <Link
                to="/become-seller"
                className={`transition-colors hover:underline ${
                  location.pathname === "/become-seller" 
                    ? "text-orange-light font-medium" 
                    : "text-gray-700 hover:text-gray-900"
                }`}
              >
                Devenir vendeur
              </Link>
            </div>

            {/* Offre du jour */}
            <div className="hidden md:flex items-center space-x-2 text-gray-700 hover:text-gray-900 transition-colors cursor-pointer font-medium">
              <span>L'offre du jour</span>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* Menu mobile */}
      {isMenuOpen && (
        <div className="md:hidden bg-white px-4 py-3 border-t border-gray-200">
          <div className="relative">
            <input
              type="text"
              placeholder="Recherche..."
              className="w-full pl-4 pr-10 py-2 text-gray-600 border border-gray-300 rounded-full focus:outline-none focus:ring-1 focus:ring-orange-light focus:border-transparent"
            />
            <button className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 15l5 5m-5-5a7 7 0 1110-10 7 7 0 01-10 10z" />
              </svg>
            </button>
          </div>
        </div>
      )}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100">
          <div className="px-4 py-2 space-y-2">
            <Link
              to="/"
              className={`block py-2 ${location.pathname === "/" ? "text-red-800 font-medium" : "text-gray-700 hover:text-gray-900"}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Accueil
            </Link>
            <Link
              to="/boutiques"
              className={`block py-2 ${location.pathname === "/boutiques" ? "text-orange-light font-medium" : "text-gray-700 hover:text-gray-900"}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Boutiques
            </Link>
            <Link
              to="/categories"
              className={`block py-2 ${location.pathname === "/categories" ? "text-orange-light font-medium" : "text-gray-700 hover:text-gray-900"}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Catégories
            </Link>
            <Link
              to="/promotions"
              className={`block py-2 ${location.pathname === "/promotions" ? "text-orange-light font-medium" : "text-gray-700 hover:text-gray-900"}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Promotions
            </Link>
            <Link
              to="/help"
              className={`block py-2 ${location.pathname === "/help" ? "text-orange-light font-medium" : "text-gray-700 hover:text-gray-900"}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Aide / FAQ
            </Link>
            <Link
              to="/become-seller"
              className={`block py-2 ${location.pathname === "/become-seller" ? "text-orange-light font-medium" : "text-gray-700 hover:text-gray-900"}`}
              onClick={() => setIsMenuOpen(false)}
            >
              Devenir vendeur
            </Link>
            <div className="block py-2 text-gray-700">
              L'offre du jour
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar; 